/* eslint-disable camelcase */
import React, { useContext } from 'react'
import { createGlobalStyle, css } from 'styled-components'

import locale from 'live/init/global-locale'
import authorization from 'live/services/authorization'
import i18n from 'live/services/i18n'

import { en_us, pt_br } from 'plugin-codaf-risk-ext-bowtie/i18n'

import { Scrollbars } from '../generic'
import { useDimensions } from '../hooks'
import {
    BowtieSettingsRouteContext,
    IBowtieSettingsRouteContext,
    IQueryParamsEdit,
    IQueryParamsList
} from './BowtieSettingWrapper'
import { RiskDiagramList, RiskDiagramEditor, BarrierList, BarrierEditor, BowtieList, BowtieEditor } from './components'
import { SettingsContainer } from './styles'

const textMap = {
    diagrams: locale === 'pt_br' ? pt_br.values['Risk Diagram'] : en_us.values['Risk Diagram'],
    barriers: locale === 'pt_br' ? pt_br.values.Barriers : en_us.values.Barriers,
    bowties: 'Bowtie'
}

const GlobalStyles = createGlobalStyle<{ params: IQueryParamsEdit | IQueryParamsList; text: string }>`
    ${({ params, text }) =>
        params.type === 'edit' &&
        css`
        .container.bowtieEditor ul li a {
            padding-right: 22px;
            border-right: 1px solid var(--gray-300);
        }

        .container.bowtieEditor ul li:last-child:after{
            content: "${textMap[text]}";
            color: var(--gray-700);
            font-family: var(--font-semibold);
            line-height: 20px;
            font-size: 14px;
        }
    `}

    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance:textfield;
    }
`

export const BowtieSettings: React.FC = () => {
    const { params, setParams } = useContext<IBowtieSettingsRouteContext<IQueryParamsEdit | IQueryParamsList>>(
        BowtieSettingsRouteContext
    ) // eslint-disable-line prettier/prettier, max-len
    const dimensions = useDimensions()
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN
    const bowtieManager = authorization.Permission.BOWTIE_MANAGER

    if ((bowtieAdmin || bowtieManager) && params.type === 'list') {
        return (
            <SettingsContainer>
                <GlobalStyles text={params.tab} params={params} />
                <div className="settings-header-wrapper">
                    <div className="container settings-header">
                        <div
                            className={`settings-header-item ${params.tab === 'diagrams' ? 'active' : ''}`}
                            onClick={() =>
                                setParams({
                                    type: 'list',
                                    tab: 'diagrams',
                                    page: 1,
                                    perPage: 50,
                                    direction: 'ASC',
                                    orderBy: 'ID'
                                })
                            }
                        >
                            {i18n('Risk Diagram')}
                        </div>
                        <div
                            className={`settings-header-item ${params.tab === 'barriers' ? 'active' : ''}`}
                            onClick={() =>
                                setParams({
                                    type: 'list',
                                    tab: 'barriers',
                                    page: 1,
                                    perPage: 50,
                                    direction: 'ASC',
                                    orderBy: 'ID'
                                })
                            }
                        >
                            {i18n('Barriers')}
                        </div>
                        <div
                            className={`settings-header-item ${params.tab === 'bowties' ? 'active' : ''}`}
                            onClick={() =>
                                setParams({
                                    type: 'list',
                                    tab: 'bowties',
                                    page: 1,
                                    perPage: 50,
                                    direction: 'ASC',
                                    orderBy: 'ID'
                                })
                            }
                        >
                            Bowtie
                        </div>
                    </div>
                </div>
                <Scrollbars height={dimensions.height} className="settings-lists-wrapper">
                    <div className="container settings-lists">
                        {params.tab === 'diagrams' && <RiskDiagramList />}
                        {params.tab === 'barriers' && <BarrierList />}
                        {params.tab === 'bowties' && <BowtieList />}
                    </div>
                </Scrollbars>
            </SettingsContainer>
        )
    } else if ((bowtieAdmin || bowtieManager) && params.type === 'edit') {
        return (
            <SettingsContainer>
                <GlobalStyles text={params.tab} params={params} />
                {params.tab === 'diagrams' && <RiskDiagramEditor />}
                {params.tab === 'bowties' && <BowtieEditor />}
                {(params.tab === 'barriers' || params.aux === 'barriers') && <BarrierEditor />}
            </SettingsContainer>
        )
    } else {
        return (
            <SettingsContainer>
                <GlobalStyles text={params.tab} params={params} />
                <div className="permissionAlert">
                    <h1>{i18n('YOU DO NOT HAVE PERMISSION TO ACCESS THE EDITOR.')}</h1>
                </div>
            </SettingsContainer>
        )
    }
}
